export class RefreshCadenceEvent {}
